import React, { Component, Fragment } from 'react';

class Databases extends Component {
  render () {
    const skillToDisplay = this.props.skills;
    // console.log(this.props.skills);
    return (
      <>
        {skillToDisplay
          ? (
            <div className='databases col m-5'>
              <ul className='newSkills'>
                <h3>Databases</h3>
                <li>
                  <i className='fas fa-check-square' />
                  MongoDb
                </li>
                <li>
                  <i className='fas fa-check-square' />
                  Firebase
                </li>
              </ul>
            </div>
            )
          : (
            <div className='databases col m-5'>
              <ul className='oldSkills'>
                <h3>Databases</h3>
                <li>
                  <i className='fas fa-check-square' />
                  Mysql
                </li>
                <li>
                  <i className='fas fa-check-square' />
                  Postgres
                </li>
              </ul>
            </div>
            )}
      </>
    );
  }
}

export default Databases;
